import React from 'react';
import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import { useIntl } from 'react-intl';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import { TranslationKey } from 'intl/types/translationKey';
import { LabelledEntity } from 'shared/types/commonView';
import { MemoMultiAutocomplete } from 'components/common/simpleInputFields/multichoice/multiAutocomplete';
import { useEntityFilterInput } from '../common';

export interface LabelledEntityFilterInputProps extends GridFilterInputValueProps {
  available: LabelledEntity[];
  labelId: TranslationKey;
}

export const LabelledEntityFilterInput: React.FC<
  LabelledEntityFilterInputProps
> = ({ item, applyValue, available, labelId }) => {
  const intl = useIntl();
  const { handleChange, selectedValues } = useEntityFilterInput(
    available,
    item,
    applyValue
  );

  return (
    <MemoMultiAutocomplete
      available={available}
      value={selectedValues}
      handleChange={handleChange}
      localisedLabel={formatTranslation(intl, unsafeTranslationKey(labelId))}
      required={false}
      error=''
      id={`labelled-entity-filter-${labelId}`}
      disableClearable={false}
      dense={true}
      reserveSpaceForHelperText={false}
      ref={null}
      size='small'
      maxVisibleTags={1}
    />
  );
};
